document.addEventListener("DOMContentLoaded", () => {
    // 会員登録フォームの氏名フリガナの制御
    const nameKana = document.getElementById("RegisterForm-NameKana");
    nameKana.addEventListener("blur", () => {
        // 空白を削除する
        nameKana.value = nameKana.value.replace(/\s+/g, "");
        // 半角カナを全角カナに変換する
        nameKana.value = changeKana(nameKana.value);
    });

    // 法人登録フォームの会社名フリガナの制御
    if (location.pathname == "/pages/register-company/") {
        const companyKana = document.getElementById("RegisterForm-CompanyKana");
        companyKana.addEventListener("blur", () => {
            // 空白を削除する
            companyKana.value = companyKana.value.replace(/\s+/g, "");
            // 半角カナを全角カナに変換する
            companyKana.value = changeKana(companyKana.value);
        });
    }

    // おもちゃ診断アプリの解答がlocalStorageに保存されている場合回答をnoteに保存する
    setBabyGiftAnswer();
});

// 半角を全角に変換する関数
const changeKana = (str) => {
    var kanaMap = {
        ｶﾞ: "ガ",
        ｷﾞ: "ギ",
        ｸﾞ: "グ",
        ｹﾞ: "ゲ",
        ｺﾞ: "ゴ",
        ｻﾞ: "ザ",
        ｼﾞ: "ジ",
        ｽﾞ: "ズ",
        ｾﾞ: "ゼ",
        ｿﾞ: "ゾ",
        ﾀﾞ: "ダ",
        ﾁﾞ: "ヂ",
        ﾂﾞ: "ヅ",
        ﾃﾞ: "デ",
        ﾄﾞ: "ド",
        ﾊﾞ: "バ",
        ﾋﾞ: "ビ",
        ﾌﾞ: "ブ",
        ﾍﾞ: "ベ",
        ﾎﾞ: "ボ",
        ﾊﾟ: "パ",
        ﾋﾟ: "ピ",
        ﾌﾟ: "プ",
        ﾍﾟ: "ペ",
        ﾎﾟ: "ポ",
        ｳﾞ: "ヴ",
        ﾜﾞ: "ヷ",
        ｦﾞ: "ヺ",
        ｱ: "ア",
        ｲ: "イ",
        ｳ: "ウ",
        ｴ: "エ",
        ｵ: "オ",
        ｶ: "カ",
        ｷ: "キ",
        ｸ: "ク",
        ｹ: "ケ",
        ｺ: "コ",
        ｻ: "サ",
        ｼ: "シ",
        ｽ: "ス",
        ｾ: "セ",
        ｿ: "ソ",
        ﾀ: "タ",
        ﾁ: "チ",
        ﾂ: "ツ",
        ﾃ: "テ",
        ﾄ: "ト",
        ﾅ: "ナ",
        ﾆ: "ニ",
        ﾇ: "ヌ",
        ﾈ: "ネ",
        ﾉ: "ノ",
        ﾊ: "ハ",
        ﾋ: "ヒ",
        ﾌ: "フ",
        ﾍ: "ヘ",
        ﾎ: "ホ",
        ﾏ: "マ",
        ﾐ: "ミ",
        ﾑ: "ム",
        ﾒ: "メ",
        ﾓ: "モ",
        ﾔ: "ヤ",
        ﾕ: "ユ",
        ﾖ: "ヨ",
        ﾗ: "ラ",
        ﾘ: "リ",
        ﾙ: "ル",
        ﾚ: "レ",
        ﾛ: "ロ",
        ﾜ: "ワ",
        ｦ: "ヲ",
        ﾝ: "ン",
        ｧ: "ァ",
        ｨ: "ィ",
        ｩ: "ゥ",
        ｪ: "ェ",
        ｫ: "ォ",
        ｯ: "ッ",
        ｬ: "ャ",
        ｭ: "ュ",
        ｮ: "ョ",
        "｡": "。",
        "､": "、",
        ｰ: "ー",
        "｢": "「",
        "｣": "」",
        "･": "・",
    };

    var reg = new RegExp("(" + Object.keys(kanaMap).join("|") + ")", "g");
    return str
        .replace(reg, function (match) {
            return kanaMap[match];
        })
        .replace(/ﾞ/g, "゛")
        .replace(/ﾟ/g, "゜");
};

const setBabyGiftAnswer = () => {
    if (localStorage.getItem("baby-gift")) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "customer[note][おもちゃ診断回答]";
        input.value = localStorage.getItem("baby-gift");
        document.getElementById("create_customer").appendChild(input);
    }
};
